import { styled } from '@mui/material'
import { TableCell as BaseTableCell } from '@chilecompra/react-kit/components'

export const Content = styled('section')`
  font-size: 14px;
  line-height: 18px;
  overflow-x: auto;
  padding-top: 16px;
  width: 100%;
`

export const Separator = styled('hr')`
  border: 0;
  border-top: 1px solid ${props => props.theme.palette.custom.gray[75.5]};
  box-sizing: content-box;
  height: 0;
  margin: 24px 0;
  overflow: visible;
`

export const TableCell = styled(BaseTableCell)`
  &.MuiTableCell-root {
    padding: ${props => props.padding || '12px 9px 16px'} !important;

    &:first-child {
      padding: ${props => props.padding || '12px 9px 16px 0'} !important;
    }

    &:last-child {
      border-right: 0;
      padding: ${props => props.padding || '12px 0 16px 9px'} !important;
    }
  }
`
